<template>
  <div>
    <v-carousel
        :cycle="slider.cycle && slidesCount > 1"
        :hide-delimiters="!slider.pagination || slidesCount === 1"
        :show-arrows="slider.navigation && slidesCount > 1"
        :interval="slider.interval * 1000"
        :height="slider.height"
    >
      <v-carousel-item v-for="(slide, i) in slider.slides" :key="i">
        <v-parallax :src="getSlideImage(slide.image)" :height="slider.height">
          <v-row align="center" justify="center" class="darken-60">
            <v-col class="slider-text" cols="12">
              <img v-if="slide.show" src="/images/logo.png" width="80" align="justify" alt="logo"/>
              <h2 v-if="slide.title" class="display-2">
                {{ slide.title }}
                <v-chip v-if="slide.new" color="red">{{ $t('New') }}</v-chip>
              </h2>
              <h3 v-if="slide.subtitle" class="display-1 font-weight-thin mt-5">
                {{ slide.subtitle }}
              </h3>
              <div v-if="slide.link.title" class="mt-5">
                <v-btn color="primary" large :href="slide.link.url">
                  {{ slide.link.title }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-parallax>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import {config} from '~/plugins/config'

export default {
  methods:{
    getSlideImage(image){
      if (window.innerWidth < 500) return image.mobileUrl || image.url
      else return image.url
    }
  },
  computed: {
    slider() {
      return config('settings.content.home.slider')
    },
    slidesCount() {
      return this.slider ? this.slider.slides.length : 0
    }
  }
}
</script>
<style lang="scss" scoped>
.darken-60 {
  background: rgba(0, 0, 0, 0.3);
}

.slider-text {
  padding-left: 105px;
  @media (max-width: 650px) {
    padding: 0 80px;
    h2 {
      font-size: 40px !important;
    }
    h3 {
      font-size: 20px !important;
      font-weight: bold !important;
    }
  }
  @media (max-width: 400px) {
    padding: 0 65px;
  }
}

</style>
